export default __webpack_public_path__ + "static/media/2000.d2b181b7.png";